import { InjectionToken } from '@angular/core';
import { environment } from '@env/environment';

export const DiOccApiUrl = new InjectionToken(`Occ API URL`, {
  providedIn: 'root',
  factory: () => environment.occ_api_url,
});
